// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../opt/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../opt/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".interactive-section{width:100%}", "",{"version":3,"sources":["webpack://./app/javascript/components/InteractiveSection/InteractiveSection.vue"],"names":[],"mappings":"AAAA,qBAAqB,UAAU","sourcesContent":[".interactive-section{width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
